import { useMemo } from 'react';

import { useForm } from '@givebacks/formy';
import { centsToDollar } from '@givebacks/utils/currency';

import { type UseFormReturnType, isInRange } from '../../../../Form';
import { CurrencyInput } from '../../../../Inputs/NumberInput/NumberInput';
import { Stack } from '../../../../Layout/Stack';
import { Text } from '../../../../Typography/Text/Text';

type PartialPaymentFormReturn = UseFormReturnType<PartialPaymentFormValues>;

type PartialPaymentFormValues = {
  amount: number;
};
type PartialPaymentFormProps = {
  /** Initial amount, if not provided, the initial amount will be 0 */
  initialAmount?: number;

  /** Minimum amount, if not provided, the minimum amount will be 1
   * @default 1
   */
  minAmount?: number;

  /** Maximum amount used for validation,  */
  maxAmount: number;
};
const PartialPaymentForm = ({
  initialAmount = 0,
  maxAmount,
  minAmount = 1,
}: PartialPaymentFormProps) => {
  const form = useForm<PartialPaymentFormValues>(
    {
      initialValues: {
        amount: initialAmount,
      },
      validate: {
        amount: isInRange(
          { min: minAmount, max: maxAmount },
          `Amount must be greater than ${minAmount} and less than the remaining balance`
        ),
      },
    },
    { id: 'partial-payment-form' }
  );
  const amountRemaining = useMemo(() => {
    return centsToDollar(maxAmount - form.values.amount);
  }, [form.values.amount, maxAmount]);
  return (
    <Stack>
      <CurrencyInput
        data-autofocus
        label="Enter Amount"
        placeholder="Amount"
        {...form.getInputProps('amount')}
      />
      <Text c="gray.6" fz="sm">
        Remaining Balance: {amountRemaining}
      </Text>
    </Stack>
  );
};
export { PartialPaymentForm };
export type { PartialPaymentFormReturn };
